import { STAR1Locales, STAR2LocalesStandalone } from '../../../utils';
import { createTranslation } from './createTranslation';

export function createTranslationsObject(locale: string) {
  const translationKey =
    !STAR1Locales.includes(locale) && !STAR2LocalesStandalone.includes(locale) ? locale.split('-')[0] : locale;

  return {
    [locale]: createTranslation(translationKey),
  };
}
